<template>
  <v-container grid-list-lg>
    <v-card>
      <v-card-title>
        <h2 class="font-weight-light">New Location</h2>
      </v-card-title>
      <v-stepper class="elevation-0" v-model="e1">
        <v-stepper-header class="elevation-0">
          <v-stepper-step :complete="e1 < 1" step="1">Store Information</v-stepper-step>
          <v-divider> </v-divider>
          <v-stepper-step :complete="e1 < 2" step="2">Select Plan</v-stepper-step>
          <v-divider> </v-divider>
          <v-stepper-step :complete="e1 < 3" step="3">Payment</v-stepper-step>
          <v-divider> </v-divider>
          <v-stepper-step step="4">Review</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <LocationInformation @nextStep="confirmStepOne"> </LocationInformation>
          </v-stepper-content>
          <v-stepper-content step="2">
            <Plans @nextStep="confirmStepTwo" @back="back"> </Plans>
          </v-stepper-content>
          <v-stepper-content step="3">
            <Payment @nextStep="confirmStepThree" @back="back"> </Payment>
          </v-stepper-content>
          <v-stepper-content step="4">
            <Review> </Review>
            <v-layout class="mt-3" row>
              <v-btn color="info" text @click="cancel" :disabled="loading">{{
                $t("buttons.cancel")
              }}</v-btn>
              <v-spacer> </v-spacer>
              <v-btn color="info" text @click="back" :disabled="loading">{{
                $t("buttons.back")
              }}</v-btn>
              <v-btn color="info" @click="save" :loading="loading"
                >{{ $t("buttons.placeOrder") }}
              </v-btn>
              <v-dialog
                v-model="loading"
                hide-overlay="hide-overlay"
                persistent="persistent"
                width="300"
              >
                <v-card color="primary" dark="dark">
                  <v-card-text
                    >Please stand by
                    <v-progress-linear class="mb-0" indeterminate="indeterminate" color="white">
                    </v-progress-linear>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-layout>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LocationInformation from "../components/Create/LocationInformation";
import Review from "../components/Create/Review";
import Plans from "../components/Create/Plans";
import signUpService from "../service";
import Payment from "../components/Create/PaymentInformation";
export default {
  data() {
    return {
      loading: false,
      e1: 1,
      plan: null
    };
  },
  computed: {
    ...mapGetters("global", ["currentOrganization"]),
    ...mapGetters("location", [
      "order",
      "review",
      "feature",
      "plans",
      "hardware",
      "store",
      "card",
      "hardwareTotal",
      "shipping",
      "signUp"
    ])
  },
  components: {
    LocationInformation,
    Review,
    Payment,
    Plans
  },
  mounted() {
    this.initOrganization();
  },
  methods: {
    ...mapActions("global", ["initOrganization"]),
    ...mapActions("location", ["location", "setSignUp"]),
    cancel() {
      this.$router.push({ name: "location-dashboard" });
    },
    back() {
      this.e1 = this.e1 - 1;
    },
    confirmStepThree() {
      this.e1 = 4;
    },
    confirmStepTwo() {
      this.e1 = 3;
    },
    confirmStepOne() {
      this.e1 = 2;
    },
    save() {
      if (!this.review.terms) {
        this.$swal("New Location", "Please Accept terms and Condition", "warning");
        return false;
      }
      this.loading = true;
      let data = {
        businessName: this.store.businessName,
        businessPhone: this.store.phoneNumber,
        businessEmail: this.store.businessEmail,
        address: this.store.address,
        city: this.store.city,
        stateID: this.store.stateID,
        zipCode: this.store.zipcode,
        country: this.store.country,
        productID: 33,
        invoiceEmail: this.store.invoiceEmail,
        orgID: this.currentOrganization.organizationID,
        organizationID: this.currentOrganization.organizationID,
        cellPhone: this.store.phoneNumber,
        shipName: this.store.businessName,
        shipAddress: this.store.address,
        shipCity: this.store.city,
        shipState: this.store.stateID,
        shipZipcode: this.store.zipcode,
        shipCountry: this.store.country,
        shipPhone: this.store.phoneNumber,
        softwareFee: this.plans.softwareFee,
        Plans: this.plans,
        FreeDays: 7
      };

      var cardData = {
        nameOnCard: this.card.nameOnCard,
        cardNumber: this.card.cardNumber.split(" ").join(""),
        expiry: this.card.cardExpiry.split("/"),
        cvvCode: this.card.cvvCode,
        streetAddress: this.card.address,
        city: this.card.city,
        state: this.card.state,
        zipcode: this.card.zipcode
      };

      cardData["month"] = cardData.expiry[0].split(" ").join("");
      cardData["year"] = cardData.expiry[1].split(" ").join("");

      data["Card"] = cardData;

      return signUpService
        .addLocation(data)
        .then(result => {
          this.location(result.data.store);
          this.setSignUp(result);
          this.loading = false;
          this.$router.push({ name: "upsale-screen", params: result });

          console.log("store data", result);
        })
        .catch(err => {
          console.log("test error", err);
          this.$swal("New Location!", err.data.data, "error").then(() => {
            this.loading = false;
          });
        });
      this.$router.push({ name: "upsale-screen" });
    }
  }
};
</script>

<style scoped></style>
